export const initialTooltipState = { text: '', anchorEl: null, visible: false };

export const SCROLL_DEBOUNCE_DELAY = 150;
